<template>
  <div
    v-if="showFeaturePanel"
    class="bg-white rounded shadow fixed bottom-1 right-1 border z-40 p-4 pb-0 m-2 max-w-sm w-full"
  >
    <div
      v-for="(feature, i) in featureList"
      :key="`feature-${i}`"
      class="flex mb-4"
    >
      <div class="w-full">
        <b>{{ feature.name.replace(/_/g, ' ') }}</b>
        <div>{{ feature.description }}</div>
      </div>
      <div class="items-center flex">
        <Switch
          v-if="feature.isToggleable"
          :key="feature.name"
          :current-value="feature.enabled"
          @toggle="(toggle: boolean) => methods.toggleFeature(feature.name, toggle)"
        />
        <div v-else>{{ feature.enabled ? 'Enabled' : 'Disabled' }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { canToggleFeatures } from '@/plugins/permissions';
import { features } from '@/services/config';
import { authState } from '@/services/integrations/auth0';
import { defineComponent, onMounted, ref } from 'vue';
import { useCookies } from 'vue3-cookies';
import Switch from '../general/Switch.vue';

export default defineComponent({
  name: 'FeatureFlagFlipper',
  components: { Switch },
  setup() {
    const showFeaturePanel = ref(false);

    const featureList = Object.keys(features).map(key => {
      return features[key];
    });

    const toggleFeature = (featureName: string, value: boolean) => {
      const cookieDomain = window.location.host.includes('localhost')
        ? 'localhost'
        : `.${window.location.host}`;

      useCookies().cookies.set(
        `PHAROS_LABS_FEATURE_FLAG_${featureName}`,
        value.toString(),
        '10d',
        '/',
        cookieDomain
      );
      window.location.reload();
    };

    const handleKeyboard = (event: KeyboardEvent) => {
      if (event.repeat) return;
      if (
        (event.metaKey || event.ctrlKey) &&
        event.shiftKey &&
        event.code === 'Space'
      ) {
        showFeaturePanel.value = !showFeaturePanel.value;
      }
    };

    onMounted(() => {
      document.addEventListener('keydown', handleKeyboard);
    });

    return {
      showFeaturePanel,
      featureList,
      authState,
      canToggleFeatures,
      methods: {
        toggleFeature,
      },
    };
  },
});
</script>
